<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-account"
      icon-small
      title="اعضا صندوق"
      color="accent"
      :loading="loading"
    >
      <template v-slot:topActons>
        <v-btn
          color="primary"
          dark
          class="mx-1"
          @click="add"
        >
          <v-icon dark>
            mdi-plus-circle-outline
          </v-icon>
          افزودن عضو
        </v-btn>
        <v-btn
          color="secondary"
          dark
          class="mx-1"
          @click="importExcel"
        >
          <v-icon dark>
            mdi-file-excel-outline
          </v-icon>
          دریافت فایل اعضا
        </v-btn>
      </template>
      <v-row>
        <v-col
          cols="12"
          style="padding:0 40px 40px"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
                single-line
                hide-details
                class="mb-5"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                dense
                :headers="headers"
                :items="members"
                :items-per-page="500"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        @click="manageLoans(row.item)"
                      >{{ row.item.firstName }}</a>
                    </td>
                    <td>
                      <a
                        href="javascript:void(0)"
                        @click="manageLoans(row.item)"
                      >{{ row.item.lastName }}</a>
                    </td>
                    <td>{{ row.item.personalCode }}</td>
                    <td>{{ row.item.nationalCode }}</td>
                    <td>{{ row.item.agentCode }}</td>
                    <td class="text-center">
                      {{ row.item.loanCount }}
                    </td>
                    <td class="text-center">
                      {{ row.item.totalLoans.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.totalRemain.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.totalSavedMoney.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.currentMonthInstallment.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.currentMonthSavedMoney.toString().toPriceFormat() }}
                    </td>

                    <td class="text-center">
                      {{ row.item.lastLoginDate_Persian.date }}
                    </td>
                    <td class="text-center">
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="green"
                        title="مدیریت وام ها"
                        @click="manageLoans(row.item)"
                      >
                        <v-icon dark>
                          mdi-cash-check
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="blue"
                        title="پس انداز ها"
                        @click="manageSavedMoney(row.item)"
                      >
                        <v-icon dark>
                          mdi-account-cash
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="secondary"
                        @click="edit(row.item)"
                      >
                        <v-icon dark>
                          mdi-square-edit-outline
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="pink"
                        @click="remove(row.item)"
                      >
                        <v-icon dark>
                          mdi-trash-can-outline
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogUser"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">مشخصات عضو</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="form"
                class="mx-2"
                lazy-validation
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="firstName"
                      v-model="localData.firstName"
                      label="نام*"
                      :error-messages="errorMessages"
                      :rules="[() => !!localData.firstName || 'نام را وارد کنید']"
                      required
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="lastName"
                      v-model="localData.lastName"
                      label="نام خانوادگی*"
                      :error-messages="errorMessages"
                      :rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="personalCode"
                      v-model="localData.personalCode"
                      label="کد پرسنلی*"
                      :error-messages="errorMessages"
                      :rules="[() => !!localData.personalCode || 'کد پرسنلی را وارد کنید']"
                      required
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="nationalCode"
                      v-model="localData.nationalCode"
                      label="کد ملی*"
                      :error-messages="errorMessages"
                      :rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید']"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="agentCode"
                      v-model="localData.agentCode"
                      label="کد عامل"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="agentTitle"
                      v-model="localData.agentTitle"
                      label="عنوان عامل"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="hoghoghiUnit"
                      v-model="localData.hoghoghiUnit"
                      label="واحد حقوقی"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="officeUnit"
                      v-model="localData.officeUnit"
                      label="واحد سازمانی"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      ref="mobile"
                      v-model="localData.mobile"
                      label="موبایل"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <div>
                      <div>تاریخ عضویت</div>
                      <date-picker
                        ref="regDate2"
                        v-model="localData.regDate2"
                        format="YYYY-MM-DDTHH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY"
                        :error-messages="errorMessages"
                        clearable
                        auto-submit
                        :rules="[() => localData.regDate2 === '' || 'تاریخ عضویت را به صورت صحیح وارد کنید']"
                      />
                      <div class="red--text">
                        {{ datePickerValidatioin }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      v-model="localData.password"
                      :rules="[() => !!localData.password || 'کلمه عبور را وارد کنید']"
                      :error-messages="errorMessages"
                      :type="'password'"
                      name="password"
                      label="کلمه عبور*"
                      hint="حداقل 8 کاراکتر"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      v-model="localData.confirmPassword"
                      :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']"
                      :error-messages="errorMessages"
                      :type="'password'"
                      name="confirmPassword"
                      label="تکرار کلمه عبور*"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      v-model="localData.isDied"
                      label="خروج از صندوق"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*فیلدهای ستاره دار ضروری هستند.</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="dialogUser = false">
              بستن
            </v-btn>
            <v-btn
              color="blue"
              dark
              @click="submit()"
            >
              ذخیره
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogLoansManager"
        max-width="900px"
      >
        <v-card>
          <v-card-title>
            <div><span class="headline">مدیریت وام</span></div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <manage-loan
                ref="manageLoan"
                :data="{member:selectedMember}"
              />
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="dialogLoansManager = false">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSavedMoneyManager"
        max-width="900px"
      >
        <v-card>
          <v-card-title>
            <div><span class="headline">پس اندازها</span></div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <manage-saved-money
                ref="manageSavedMoeny"
                :data="{member:selectedMember}"
              />
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="dialogSavedMoneyManager = false">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogImportExcel"
        max-width="1200px"
      >
        <v-card>
          <v-card-title>
            <div><span class="headline">دریافت فایل اکسل اعضا</span></div>
          </v-card-title>
          <v-card-text>
            <member-import
              ref="memberImport"
              @upload="loadData"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="dialogImportExcel = false">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import ManageLoan from './ManageLoan.vue'
  import ManageSavedMoney from './ManageSavedMoney.vue'
  import MemberImport from './ImportFile/MemberImport.vue'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  export default {
    name: 'MembersView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'manage-loan': ManageLoan,
      'manage-saved-money': ManageSavedMoney,
      'member-import': MemberImport,
      'date-picker': VuePersianDatetimePicker,
    },
    data () {
      return {
        errorMessages: '',
        datePickerValidatioin: '',
        localData: {},
        selectedMember: {},
        dialogUser: false,
        dialogLoansManager: false,
        dialogSavedMoneyManager: false,
        dialogImportExcel: false,
        search: '',
        loading: false,
        headers: [
          {
            text: 'نام',
            align: 'start',
            sortable: true,
            value: 'firstName',
          },
          {
            text: 'نام خانوادگی',
            align: 'start',
            sortable: true,
            value: 'lastName',
          },
          {
            text: 'کد پرسنلی',
            align: 'center',
            sortable: true,
            value: 'personalCode',
          },
          {
            text: 'کد ملی',
            align: 'center',
            sortable: true,
            value: 'nationalCode',
          },
          {
            text: 'کد عامل',
            align: 'start',
            sortable: true,
            value: 'agentCode',
          },
          {
            text: 'تعداد وام',
            align: 'start',
            sortable: true,
            value: 'loanCount',
          },
          {
            text: 'مجموع وام های دریافتی',
            align: 'start',
            sortable: true,
            value: 'totalLoans',
            width: 150,
          },
          {
            text: 'مانده اقساط',
            align: 'center',
            sortable: true,
            value: 'totalRemain',
          },
          {
            text: 'پس انداز',
            align: 'center',
            sortable: true,
            value: 'totalSavedMoney',
          },
          {
            text: 'اقساط این ماه',
            align: 'center',
            sortable: true,
            value: 'currentMonthInstallment',
            width: 150,
          },
          {
            text: 'پس انداز این ماه',
            align: 'center',
            sortable: true,
            value: 'currentMonthSavedMoney',
            width: 150,
          },
          {
            text: 'آخرین ورود',
            align: 'center',
            sortable: true,
            value: 'lastLoginDate_Persian.date',
          },
          {
            text: 'عملیات ها',
            align: 'center',
            sortable: false,
            width: 225,
          },
        ],
        members: [],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        api
          .get('admin/member/list', null)
          .then((response) => {
            this.members = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
          .finally((x) => {
            this.loading = false
          })
      },
      add () {
        api
          .get('admin/member/get/0', null)
          .then((response) => {
            this.localData = response
            if (this.localData.regDate2 === '0001-01-01T00:00:00') {
              this.localData.regDate2 = ''
            }
            this.dialogUser = true
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
      edit (item) {
        api
          .get('admin/member/get/' + item.id, null)
          .then((response) => {
            this.localData = response
            if (this.localData.regDate2 === '0001-01-01T00:00:00') {
              this.localData.regDate2 = ''
            }
            this.dialogUser = true
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
      submit () {
        this.datePickerValidatioin = ''
        if (this.localData.regDate2 === '') {
          this.datePickerValidatioin = 'تاریخ را وارد کنید'
          return
        }
        if (!this.$refs.form.validate()) {
          return
        }

        api
          .post(
            'admin/member/' + (this.localData.id === 0 ? 'create' : 'edit'),
            this.localData,
          )
          .then((response) => {
            toast.success('اطلاعات با موفقیت ذخیره شد.')
            this.loadData()
            this.dialogUser = false
          })
          .catch((err) => {
            toast.error(err.message)
          })
      },
      async remove (item) {
        if (!item) {
          return
        }

        if (
          await this.$refs.confirm.open(
            'توجه',
            'آیا از حذف این آیتم مطمئن هستید؟',
          )
        ) {
          api
            .post('admin/member/delete/' + item.id)
            .then((response) => {
              toast.success('اطلاعات با موفقیت حذف شد.')
              this.loadData()
            })
            .catch((err) => {
              toast.error(err.message)
            })
        }
      },
      manageLoans (item) {
        this.selectedMember = item
        this.dialogLoansManager = true
        this.$nextTick(() => {
          this.$refs.manageLoan.loadData()
        })
      },
      manageSavedMoney (item) {
        this.selectedMember = item
        this.dialogSavedMoneyManager = true
        this.$nextTick(() => {
          this.$refs.manageSavedMoeny.loadData()
        })
      },
      importExcel () {
        this.dialogImportExcel = true
        this.$nextTick(() => {
          this.$refs.memberImport.prepareData()
        })
      },
    },
  }
</script>
<style>
</style>
